import React, { PropTypes } from 'react';
import fetch from 'node-fetch';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import PureComponent from 'components/PureComponent';

import { Link } from 'react-router';
import Button from 'components/Button';

import assign from 'object.assign';
import debounce from 'debounce';
import cookie from 'react-cookies';

const https = require('https');

class CityConfirm extends React.Component {
  constructor() {
    super();
    this.state = {};

    this.handleCityAccept = this.handleCityAccept.bind(this);
    this.saveCityLink = this.saveCityLink.bind(this);
  }

  static contextTypes = {
    deviceType: PropTypes.string
  };

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func
    //cityInfo: PropTypes.object
  };

  static defaultProps = {
    isOpen: false
  };

  saveCityLink() {
    var exist = cookie.load('link');

    if (exist) {
      return;
    }

    var citiesRows = this.state.cities;
    loop1: for (var i in citiesRows) {
      loop2: for (var j in citiesRows[i].blocks) {
        loop3: for (var k in citiesRows[i].blocks[j].cities) {
          if (citiesRows[i].blocks[j].cities[k].title == this.state.city) {
            cookie.save('link', citiesRows[i].blocks[j].cities[k].link);
            break loop1;
          }
        }
      }
    }
  }

  handleCityAccept() {
    var citiesRows = this.state.cities;
    loop1: for (var i in citiesRows) {
      loop2: for (var j in citiesRows[i].blocks) {
        loop3: for (var k in citiesRows[i].blocks[j].cities) {
          if (citiesRows[i].blocks[j].cities[k].title == this.state.city) {
            cookie.save('link', citiesRows[i].blocks[j].cities[k].link);
            break loop1;
          }
        }
      }
    }

    cookie.save('city', this.state.city);
    this.props.onClose();
  }

  componentDidMount() {
    fetch('https://api.sypexgeo.net/vAR09/json')
      .then(r => r.json())
      .then(cityInfo => {
        if (cityInfo.city) {
          if (cityInfo.city.name_ru && cityInfo.city.name_ru != '') {
            this.setState({ city: cityInfo.city.name_ru });
          } else {
            this.setState({ city: cityInfo.country.capital_ru });
          }
        } else {
          console.log(cityInfo);
        }
      })
      .catch(err => {
        console.log('Error: ' + err.message);
      });

    fetch('/files/cities.json')
      .then(r => r.json())
      .then(data => {
        this.setState({ cities: data.rows });
      })
      .catch(err => {
        console.log('Error: ' + err.message);
      });
  }

  render() {
    require('./CityConfirm.styl');
    const { deviceType } = this.context;
    const { isOpen } = this.props;

    const style = assign(this.props.style || {}, {
      display: isOpen ? 'flex' : 'none'
    });

    this.saveCityLink();

    if (this.state && this.state.city) {
      return (
        <div className="CityConfirm" style={!isOpen ? { display: 'none' } : {}}>
          <span className="CityConfirm__text">
            {'Ваш город — ' + this.state.city}
          </span>

          <Button
            component="a"
            style={{
              //flex: 'auto',
              margin: 'auto',
              width: 50,
              flexBasis: 'fill',
              //flexBasis: 'fill'
              color: '#fff',
              borderColor: '#21c8ff',
              backgroundColor: '#21c8ff'
              // marginLeft: 16,
              // float: 'right',
            }}
            onClick={this.handleCityAccept}
          >
            Да
          </Button>

          <Link
            component="a"
            to={'/city'}
            className="Button"
            style={{
              //flex: 'auto',
              margin: 'auto',
              width: 60,
              flexBasis: 'fill',
              marginLeft: 10
              // color: '#21C8FF',
              // background: 'none',
              // border: '2px solid',
              // borderRadius: '4px',
              //
              // transition: color 0.3s, border-color 0.3s, width 0.3s, border-radius 0.3s
              //display: 'flex'
              // paddingLeft: 18,
              // paddingRight: 18
            }}
          >
            Нет
          </Link>
        </div>
      );
    }

    return <span />;
  }
}

export default CityConfirm;



// WEBPACK FOOTER //
// ./src/components/CityConfirm/CityConfirm.js